"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalProps = void 0;
var tslib_1 = require("tslib");
/**
 * @file modal 的内部逻辑处理，抽出来可以分别提供给 Modal 和 Dialog
 */
var react_1 = tslib_1.__importStar(require("react"));
var hooks_1 = require("../utils/hooks");
var icons_1 = require("../icons");
var Footer_1 = tslib_1.__importStar(require("./Footer"));
var PopupContainerProvider_1 = require("../PopupContainerProvider");
var utils_1 = require("../utils");
function useModalProps(props, prefix) {
    var _this = this;
    var _a = props.footer, footer = _a === void 0 ? react_1.default.createElement(Footer_1.default, null) : _a, onOk = props.onOk, onCancel = props.onCancel, width = props.width, title = props.title, visibleFromProps = props.visible, style = props.style, rootHtmlProps = props.rootHtmlProps, maskHtmlProps = props.maskHtmlProps, _b = props.autoDestroy, autoDestroy = _b === void 0 ? false : _b, _c = props.maskClickable, maskClickable = _c === void 0 ? false : _c, children = props.children, className = props.className, _d = props.keyboard, keyboard = _d === void 0 ? true : _d;
    var _e = hooks_1.useValue({ valueFromProps: visibleFromProps, defaultValue: true }), visible = _e.value, setVisible = _e.setValue;
    var popupContainerRef = react_1.useRef(null);
    var handleOk = react_1.useCallback(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (onOk === null || onOk === void 0 ? void 0 : onOk())];
                case 1:
                    _a.sent();
                    setVisible(false);
                    return [2 /*return*/];
            }
        });
    }); }, [onOk, setVisible]);
    var handleCancel = react_1.useCallback(function () {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        setVisible(false);
    }, [onCancel, setVisible]);
    var handleMaskClick = react_1.useCallback(function (e) {
        var _a;
        (_a = maskHtmlProps === null || maskHtmlProps === void 0 ? void 0 : maskHtmlProps.onClick) === null || _a === void 0 ? void 0 : _a.call(maskHtmlProps, e);
        if (e.defaultPrevented)
            return;
        if (!maskClickable)
            return;
        handleCancel();
    }, [maskHtmlProps, maskClickable, handleCancel]);
    var footerCtxValue = react_1.useMemo(function () { return ({
        onOk: handleOk,
        onCancel: handleCancel
    }); }, [handleOk, handleCancel]);
    var footerView = (react_1.default.createElement(Footer_1.footerCtx.Provider, { value: footerCtxValue }, footer));
    var realChildren = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: utils_1.concat(prefix, 'popup', 'container'), ref: popupContainerRef }),
        react_1.default.createElement(PopupContainerProvider_1.PopupContainerProvider, { containerRef: popupContainerRef }, children)));
    return {
        handleOk: handleOk,
        handleCancel: handleCancel,
        maskProps: tslib_1.__assign(tslib_1.__assign({}, maskHtmlProps), { visible: visible, onClick: handleMaskClick, autoDestroy: autoDestroy }),
        rcDialogProps: {
            prefixCls: prefix,
            wrapProps: rootHtmlProps,
            visible: visible,
            mask: false,
            footer: footerView,
            closeIcon: react_1.default.createElement(icons_1.CloseIcon, null),
            width: width,
            style: style,
            onClose: handleCancel,
            children: realChildren,
            title: title,
            className: className,
            keyboard: keyboard
        }
    };
}
exports.useModalProps = useModalProps;
//# sourceMappingURL=hooks.js.map